import React from 'react';
import {
  Box,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles
} from '@material-ui/core';
import { AlternatingColorTableRow } from 'src/components/table';

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  formikHookRef: any;
}

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)'
  },
  body: {
    backgroundColor: theme.palette.background.paper,
    width: '1200px',
    maxHeight: '600px',
    borderRadius: 8,
    border: '2px solid black',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    overflow: 'hidden',
    margin: '5em'
  },
  header: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    fontSize: '2em'
  },
  tableContainer: {
    flex: 1,
    overflowY: 'auto'
  },
  tableHeadCell: {
    fontWeight: 'bold',
    verticalAlign: 'top',
    textAlign: 'left'
  },
  tableBodyCell: {
    verticalAlign: 'top',
    textAlign: 'left'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(1)
  }
}));

const RMAInternalDiagnosisModal: React.FC<Props> = ({
  open,
  setOpen,
  formikHookRef
}) => {
  const classes = useStyles();

  const diagnoses = Array.isArray(formikHookRef?.values?.['internal_diagnosis'])
    ? [...formikHookRef.values['internal_diagnosis']].reverse()
    : [];

  return (
    <Modal
      open={open}
      className={classes.modalContainer}
      BackdropProps={{ className: classes.backdrop }}
    >
      <Box className={classes.body}>
        <Typography variant="h6" className={classes.header}>
          Internal Diagnosis
        </Typography>

        <Box className={classes.tableContainer}>
          <Table stickyHeader>
            {diagnoses?.length > 0 ? (
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeadCell}>Date</TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    Diagnosis
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>Tech</TableCell>
                </TableRow>
              </TableHead>
            ) : null}

            <TableBody>
              {diagnoses.length > 0 ? (
                diagnoses.map((diag, index) => (
                  <AlternatingColorTableRow key={index} hover>
                    <TableCell className={classes.tableBodyCell}>
                      {diag.date_time}
                    </TableCell>
                    <TableCell
                      className={classes.tableBodyCell}
                      style={{ whiteSpace: 'pre-line' }}
                    >
                      {diag.remarks}
                    </TableCell>
                    <TableCell className={classes.tableBodyCell}>
                      {diag.performed_by}
                    </TableCell>
                  </AlternatingColorTableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <Typography variant="body2" color="textSecondary">
                      No internal diagnosis available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>

        <Box className={classes.footer}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RMAInternalDiagnosisModal;
